const getApplicationConfigQuery = (version, params) =>
    `query ApplicationConfigQuery {
        getApplicationConfig_${version}(${params.join(', ')}) {
          pdfAvailability {
            item
            isNew
          }
          pdfAvailability_bk
        }
      }`;

export default getApplicationConfigQuery;
